module.exports = __webpack_public_path__ + "img/icon-payment-mehtod-cupo.4527a8ef.svg";